<template>
  <g-master name="groups"
            :endpoint="master.endpoint"
            :tableSetup="master.tableSetup"
            :modalFieldsSetup="master.modalFieldsSetup"
            :parentData="parentData"
            ref="master"
  >
    <template slot="masterModal" slot-scope="{record}">
      <a-row :gutter="[16,16]">
        <a-col v-bind="colOptions">
          <a-col v-bind="colOptions">
            <g-dropdown endpoint="hierarchy_lookup"
                        :label="$t('Grupo')"
                        :formItemConfig="fiOptions"
                        :decorator="['id_h_groups', { rules: [{ required: true, message: 'Valor requerido' }] }]"
                        :params="grupo">
            </g-dropdown>
          </a-col>
        </a-col>
      </a-row>
    </template>
  </g-master>
</template>

<script>
  export default {
    props: ['name'],
    data () {
      return {
        colOptions: {xs: 24, sm: 24},
        fiOptions: {
          'label-col': {},
          'wrapper-col': {}
        },
        master: {
          endpoint: 'user_group',
          tableSetup: {
            tableConfig: {
              rowKey: 'id'
            },
            columns: [
              {title: 'Grupos', dataIndex: 'h_groups', sorter: true}
            ]
          },
          modalFieldsSetup: [
            {name: 'user_name'},
            {name: 'id_h_groups'}
          ]
        },
        grupo: {
          h_lookup_type: 'ID_H_ATT1'
        }
      }
    },
    computed: {
      parentData () {
        return {
          user_name: this.name
        }
      }
    }
  }
</script>


// WEBPACK FOOTER //
// src/customization/GlobalBPOCore/pages/Mantenimiento/User/MantenimientoUserGroups.vue